// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"66":"7b9b02e379f28097","137":"28a64c243711d98e","630":"561359f5bd344b4f","912":"1b47eede93143175","937":"3c3a6298321ae096"}[chunkId] + ".js";
};